// جدولِ تاریخچهٔ بکاپ — یک کامپوننت، دو کاربرد (دیتابیس / فایل‌ها).
// در صفحهٔ «بکاپ» با دکمه‌های دانلود/حذف، و در صفحهٔ «بازیابی» به‌عنوان انتخاب‌گر.
import React from "react";
import { Button, Popconfirm, Space, Table, Tag, Tooltip, Typography } from "antd";
import { DeleteOutlined, DownloadOutlined, SafetyOutlined } from "@ant-design/icons";
import { toJalali } from "../../../utils/dateUtils";

const { Text } = Typography;

const SOURCE = {
  auto: { l: "خودکار", c: "blue" },
  manual: { l: "دستی", c: "geekblue" },
  uploaded: { l: "آپلودی", c: "purple" },
  pre_update: { l: "پیش از بروزرسانی", c: "gold" },
  pre_restore: { l: "پیش از بازیابی", c: "orange" },
};

const STORAGE = {
  local: "سرور",
  "local+telegram": "سرور + تلگرام",
  telegram: "تلگرام",
};

export const humanSize = (b) =>
  !b ? "—" : b > 1048576 ? (b / 1048576).toFixed(1) + " MB" : (b / 1024).toFixed(0) + " KB";

export default function BackupHistoryTable({
  rows, loading, selectedId, onSelect, onDownload, onDelete, onVerify,
  compact = false, pageSize = 8,
}) {
  const cols = [
    {
      title: "تاریخ", dataIndex: "created_at", width: 140,
      render: (v) => toJalali(v) || "—",
    },
    {
      title: "نسخهٔ برنامه", dataIndex: "app_version", width: 110,
      render: (v) => (v ? <Tag>{v}</Tag> : <Text type="secondary">—</Text>),
    },
    { title: "حجم", dataIndex: "size_bytes", width: 90, render: humanSize },
    {
      title: "محل ذخیره", dataIndex: "storage_location", width: 120,
      render: (v) => STORAGE[v] || v || "سرور",
    },
    {
      title: "منشأ", dataIndex: "source", width: 130,
      render: (s) => <Tag color={SOURCE[s]?.c}>{SOURCE[s]?.l || s}</Tag>,
    },
    {
      title: "وضعیت", dataIndex: "status", width: 90,
      render: (s, r) => (
        <Space size={4}>
          <Tag color={s === "ok" ? "green" : "red"}>{s === "ok" ? "سالم" : "ناموفق"}</Tag>
          {r.encrypted && <Tooltip title="رمزنگاری‌شده"><SafetyOutlined /></Tooltip>}
        </Space>
      ),
    },
    {
      title: "چک‌سام", dataIndex: "checksum", width: 110,
      render: (v) => v
        ? <Tooltip title={v}><Text code style={{ fontSize: 11 }}>{v.slice(0, 10)}…</Text></Tooltip>
        : <Text type="secondary">—</Text>,
    },
    {
      title: "کانال‌ها", dataIndex: "channels_result", width: 150,
      render: (c) => c
        ? Object.entries(c)
            .filter(([k]) => !k.endsWith("_parts") && !k.endsWith("_mode"))
            .map(([k, v]) => (
              <Tooltip key={k} title={String(v)}>
                <Tag color={String(v).startsWith("ok") ? "green" : "orange"}>
                  {k}: {String(v).startsWith("ok") ? "✓" : "✗"}
                </Tag>
              </Tooltip>
            ))
        : <Text type="secondary">—</Text>,
    },
  ];

  if (!compact) {
    cols.push({
      title: "عملیات", key: "act", width: 130, fixed: "left",
      render: (_, r) => (
        <Space size={4}>
          {onVerify && (
            <Tooltip title="بررسی صحت">
              <Button size="small" icon={<SafetyOutlined />} onClick={() => onVerify(r)} />
            </Tooltip>
          )}
          <Tooltip title="دانلود">
            <Button size="small" icon={<DownloadOutlined />} onClick={() => onDownload(r)} />
          </Tooltip>
          <Popconfirm title="این بکاپ حذف شود؟" description="فایل از سرور پاک می‌شود."
            onConfirm={() => onDelete(r.id)} okText="بله، حذف" cancelText="انصراف" okButtonProps={{ danger: true }}>
            <Tooltip title="حذف"><Button size="small" danger icon={<DeleteOutlined />} /></Tooltip>
          </Popconfirm>
        </Space>
      ),
    });
  }

  return (
    <Table
      rowKey="id" size="small" columns={cols} dataSource={rows} loading={loading}
      pagination={{ pageSize, size: "small", hideOnSinglePage: rows.length <= pageSize }}
      scroll={{ x: "max-content" }}
      locale={{ emptyText: "هنوز بکاپی ثبت نشده است" }}
      rowSelection={onSelect ? {
        type: "radio",
        selectedRowKeys: selectedId ? [selectedId] : [],
        onChange: (k) => onSelect(k[0]),
        getCheckboxProps: (r) => ({ disabled: r.status !== "ok" }),
      } : undefined}
    />
  );
}
